{
  "name": "m",
  "version": "1.0.0",
  "author": "Mathieu CAROFF <mathieu.caroff@free.fr>",
  "repository": "https://github.com/mathieucaroff/colorcube",
  "license": "NTP",
  "scripts": {
    "build": "parcel build src/index.html --dist-dir public",
    "mcabuild": "parcel build src/index.html --public-url colorcube.d",
    "serve": "parcel serve src/index.html"
  },
  "devDependencies": {
    "@types/react": "^17.0.39",
    "@types/react-dom": "^17.0.11",
    "@types/three": "^0.131.0",
    "parcel": "^2.2.1",
    "typescript": "^4.5.5"
  },
  "dependencies": {
    "@types/lodash": "^4.14.191",
    "antd": "^4.18.5",
    "lil-gui": "^0.17.0",
    "lodash": "^4.17.21",
    "react": "^17.0.2",
    "react-dom": "^17.0.2",
    "three": "^0.132.2"
  }
}
